var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"host",staticClass:"codegen-diff-host",style:(`height: ${_vm.height}px; overflow: auto; border: 1px solid #ced4da; border-radius: 4px; font-size: 13px;`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }